"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  events: ['onChange', 'onBlur'],
  errorClass: 'invalid-field'
};
exports.default = _default;
module.exports = exports["default"];